import { Outlet } from 'react-router-dom'

// The `ProtectedOutlet` component wraps the `Outlet` from `react-router-dom`
// and provides a context object (`outletContext`) containing the passed props.
// This allows child routes to access the context via `useOutletContext`.
const ProtectedOutlet = ({ ...props }) => {
  const outletContext = {
    props: props,
  }

  return (
    <div>
      <Outlet context={outletContext} />
    </div>
  )
}

export default ProtectedOutlet
